import Vue from 'vue'
import $https from '@/plugins/axios'

let state = {
  isProjectMode: false,
  user: null
}

const getters = {
  user: state => {
    return state.user
  }
}

const mutations = {
  SET_ADMIN_PROJECT_MODE: (state, isProjectMode) => {
    state.isProjectMode = isProjectMode
    if (state.isProjectMode && state.user) {
      state.user.isAdmin = false
    }
  },
  SET_USER: (state, user) => {
    state.user = user
    if (state.isProjectMode && state.user) {
      state.user.isAdmin = false
    }
  },
  SET_USER_SELECTED_PROJECT: (state, selectedProject) => {
    Vue.set(state.user, 'selectedProject', selectedProject)
  }
}

const actions = {
  async GetUserInfo ({ commit }) {
    const responseData = await $https.axios({ method: 'get', url: 'user/selectCurrentUser' })
    commit('SET_USER', responseData.data)
    return responseData.data
  },
  Logout ({ commit }) {
    commit('SET_USER', null)
    Vue.prototype.$socket.close()
    if (sessionStorage.getItem('E-User-Token')) {
      $https.axios({ url: 'user/logout' })
    }
  },
  async AutoLogout ({ dispatch }) {
    sessionStorage.removeItem('E-User-Token')
    await dispatch('Logout')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js